import LocationInterface from '@solvhealth/types/interfaces/Location';
import { getLocationStatus, isTelemedConnect } from '~/core/util/location';
import { NearbyLocations } from '~/components/ClinicDetailPageFlexible/ContextProviders';

export const NEARBY_MODULE_TIMED_POPUP = 'nearby module timed popup';
export const NEARBY_MODULE_DESKTOP = 'nearby module desktop';
export const N0_NEARBY_MODULE = 'no nearby module';
export const CALL_FOR_VISIT = 'call for visit';
export const FIND_MORE_LOCATIONS = 'find more locations';

export const getPartnerLocationIdList = (nearbyLocations?: NearbyLocations) => {
  return nearbyLocations?.connect?.map((nearbyLocation: LocationInterface) => nearbyLocation.id);
};

export const getPartnerGroupIdList = (nearbyLocations?: NearbyLocations) => {
  return nearbyLocations?.connect?.map(
    (nearbyLocation: LocationInterface) => nearbyLocation.groups[0].group_id
  );
};

export const getViewableSlotsCount = (
  maxSlots: number,
  todaySlots: number,
  tomorrowSlots: number
) => {
  if (todaySlots >= maxSlots) {
    return { today: maxSlots, tomorrow: 0 };
  }
  if (todaySlots + tomorrowSlots >= maxSlots) {
    return { today: todaySlots, tomorrow: maxSlots - todaySlots };
  }
  return { today: todaySlots, tomorrow: tomorrowSlots };
};

export const getAllPartnerCount = (nearbyLocations?: NearbyLocations) => {
  const partnerCount = {
    connect: 0,
    boost: 0,
    telemed: 0,
    pausedPartner: 0,
  };

  nearbyLocations?.connect?.forEach((nearbyLocation: LocationInterface) => {
    if (nearbyLocation) {
      const locationStatus = getLocationStatus(nearbyLocation);
      if (isTelemedConnect(nearbyLocation)) {
        partnerCount.telemed += 1;
      } else if (locationStatus === 'connect') {
        partnerCount.connect += 1;
      } else if (locationStatus === 'boost') {
        partnerCount.boost += 1;
      } else if (locationStatus === 'paused' || locationStatus === 'unbookablePartner') {
        partnerCount.pausedPartner += 1;
      }
    }
    return;
  });

  return partnerCount;
};
